var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1641 0.833008H6.83073C3.56769 0.833008 0.914062 3.48663 0.914062 6.74967V42.2497C0.914062 45.5127 3.56769 48.1663 6.83073 48.1663H54.1641C57.4271 48.1663 60.0807 45.5127 60.0807 42.2497V6.74967C60.0807 3.48663 57.4271 0.833008 54.1641 0.833008ZM14.2266 9.70801C15.4035 9.70801 16.5322 10.1755 17.3643 11.0077C18.1965 11.8399 18.6641 12.9686 18.6641 14.1455C18.6641 15.3224 18.1965 16.4511 17.3643 17.2833C16.5322 18.1155 15.4035 18.583 14.2266 18.583C13.0497 18.583 11.921 18.1155 11.0888 17.2833C10.2566 16.4511 9.78906 15.3224 9.78906 14.1455C9.78906 12.9686 10.2566 11.8399 11.0888 11.0077C11.921 10.1755 13.0497 9.70801 14.2266 9.70801ZM30.4974 39.2913H9.78906L21.6224 24.4997L26.0599 30.4163L34.9349 18.583L51.2057 39.2913H30.4974Z",
    fill: "#8F9BB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.878961f8858b17c1d70b3ad47e91b0ba.svg";
export { ForwardRef as ReactComponent };